<template>
  <!-- RT1: the Delete behind each Task & Event settings list (it used to do nothing) -->
  <Dialog
    :visible="visible"
    header="Confirm"
    :style="{ width: '380px' }"
    :modal="true"
    @update:visible="val => $emit('update:visible', val)"
  >
    <div class="confirmation-content">
      <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
      <span>Delete the {{ what }} "{{ label }}"? This can't be undone.</span>
    </div>
    <template #footer>
      <Button label="No" icon="pi pi-times" class="p-button-text" :disabled="sending" @click="cancel" />
      <Button label="Yes" icon="pi pi-check" class="p-button-text" :disabled="sending" autofocus @click="confirm" />
    </template>
  </Dialog>
</template>

<script>
import ActivityService from "@/service/ActivityService";

export default {
  props: {
    visible: { type: Boolean, default: false },
    row: { type: Object, default: null },
    list: { type: String, required: true }, // the v1/<list>/{id} DELETE endpoint
    label: { type: String, default: '' },
    what: { type: String, default: 'item' }
  },
  data: () => ({
    activityService: new ActivityService(),
    sending: false
  }),
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    confirm() {
      const row = this.row
      if (!(row && row.id) || this.sending) return
      this.sending = true
      return this.activityService
        .deleteSetting(this.list, row.id)
        .then(() => {
          this.$toast.add({ severity: 'success', summary: 'Deleted', detail: `"${this.label}" was deleted.`, life: 5000 })
          this.$emit('update:visible', false)
          this.$emit('deleted', row)
        })
        .catch(err => {
          // the server says why (409 system row / no Delete right, 404 unknown id); with no message, the
          // likeliest cause is a row that tasks and events still use
          const data = err && err.response && err.response.data
          const reason = data && data.error && typeof data.error.message === 'string' ? data.error.message : ''
          this.$toast.add({
            severity: 'error',
            summary: 'Not deleted',
            detail: reason || `"${this.label}" was not deleted. It may still be used by tasks or events; set it to Inactive instead.`,
            life: 8000
          })
          this.$emit('update:visible', false)
        })
        .finally(() => { this.sending = false })
    }
  }
}
</script>
